export enum ColumnType {
  TEXT = 'alignLeft',
  DATE = 'alignLeft',
  NUMERICAL = 'numericColumn',
  ICON = 'alignCenter',
  BOOLEAN = 'alignCenter',
  BUTTON = 'alignRight',
  PERCENT = 'percent'
}
